import { render } from "./index.vue?vue&type=template&id=1ddfe588&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1ddfe588&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1ddfe588"

export default script